





























































































import { vxm } from '../store.vuex';
import { Component, Vue, Watch } from 'vue-property-decorator';
import { AuthParams } from '@/models/userdata/authparams';
import VueRecaptcha from 'vue-recaptcha';
import { Frictionless } from '../models/referrals/frictionless';
import { ReferralPayload } from '../models/referrals/referralPayload';
import { Referral } from '../models/referrals/referral';
import router from '../router';
import VueToastr from '@deveodk/vue-toastr';
import '@deveodk/vue-toastr/dist/@deveodk/vue-toastr.css';
import { Job } from '@/models/jobs/job';
import { User } from '@/models/userdata/userdto';

Vue.use(VueToastr, {
  defaultPosition: 'toast-top-right',
  defaultType: 'info',
  defaultTimeout: 3000,
});

@Component({
  name: 'QuickSignup',
  components: {
    VueRecaptcha,
  },
})
export default class QuickSignup extends Vue {
  private firstName: string = '';
  private lastName: string = '';
  private email: string = '';
  private phone: string = '';
  private errorString: string = '';
  private user: User = new User();
  $wlToastr: any;

  mounted() {
    vxm.users.setToken('');
    vxm.users.setRefreshToken('');
    vxm.users.setAuthStatus(false);
    const vm = this;
    if (vm.$route.query.firstName) {
      vm.user.firstName = vm.$route.query.firstName.toString();
    }
    if (vm.$route.query.lastName) {
      vm.user.lastName = vm.$route.query.lastName.toString();
    }
    if (vm.$route.query.phone) {
      vm.user.phone = vm.$route.query.phone.toString();
    }
    if (vm.$route.query.email) {
      vm.user.email = vm.$route.query.email.toString();
    }
  }

  get maxlengthEmailOrMobile() {
    return this.isNumber(this.email) ? '10' : '50';
  }

  get CaptchaClientSiteKey() {
    return vxm.configs.getGlobalConfigValue('RECAPTCHA_CLIENT_SITE_KEY');
  }

  quickRegisterUser() {
    const vm = this;
    if (!vm.validateQuickSignupForm()) {
      vm.$wlToastr('error', vm.$t(vm.errorString), 'Quick Signup');
    } else {
      const referral = new Referral();
      referral.email = this.user.email;
      referral.companyCode = vxm.jobs.BrandingInfo.companycode;
      const respPromise: any = vxm.referrals.checkQuickSignupUserexist(
        referral,
      );

      Promise.all([respPromise]).then((values) => {
        this.user.companyCode = vxm.jobs.BrandingInfo.companycode;
        if (!values[0].success) {
          if (values[0].errorCode === '90' || '20') {
            vm.$wlToastr(
              'info',
              this.$t('quicksignup.already.registered.text'),
              'Sign up',
            );
          } else {
            vxm.referrals.userQuickRegister(this.user);
          }
        } else {
          vxm.referrals.userQuickRegister(this.user);
        }
      });
    }
  }

  onCaptchaVerified(recaptchaToken) {
    vxm.referrals.getRecaptchaResponse(recaptchaToken);
  }

  validateQuickSignupForm(): boolean {
    const vm = this;
    if (!vm.user.firstName) {
      this.errorString = 'quicksignup.firstname.required';
      return false;
    }

    if (!vm.user.lastName) {
      this.errorString = 'quicksignup.lastName.required';
      return false;
    }

    if (!vm.user.email) {
      this.errorString = 'quicksignup.email.required';
      return false;
    }

    if (this.isNumber(vm.user.phone) && vm.user.phone.length !== 10) {
      this.errorString = 'quicksignup.phone.valid';
      return false;
    }

    if (
      vm.user.email.includes('@') === false ||
      vm.user.email.includes('.') === false
    ) {
      this.errorString = 'quicksignup.enter.valid.email';
      return false;
    }

    if (!vxm.referrals.RecaptchaResponse.success) {
      this.errorString = 'quicksignup.enter.recaptcha.response';
      return false;
    }
    return true;
  }

  isNumber(value: string | number): boolean {
    return value != null && !isNaN(Number(value.toString()));
  }
}
